class MobileNavigation extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.mobile-nav__trigger');
    this.dialog = this.querySelector('.mobile-nav__dialog');
    this.closeButton = this.querySelector('.mobile-nav__close');

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.dialog.close();
      }
    });
    this.dialog.addEventListener('close', () => {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.focus();
    });
    this.dialog.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => this.dialog.close());
    });
  }

  open() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dialog.showModal();
    this.closeButton.focus();
  }
}

if (!customElements.get('mobile-navigation')) {
  customElements.define('mobile-navigation', MobileNavigation);
}
